import { httpInstance } from '@/services/httpInstance';

const updateCommissionService = async (dataParam) => {
  let res;
  const endpoint = '/back-office/v1/commissions/';
  const dataSent = dataParam;

  // Data transformation
  await httpInstance.put(
    endpoint,
    dataSent,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default updateCommissionService;
